import { cn, Modal } from '@artprov/design-system'
import React from 'react'
import PanelAutorizantes from '../../../common/components/PanelAutorizantes'

export default function ModalAutorizantes({ openModal, onCloseModal, autorizantes }) {
    return (
        <Modal.Container
            open={openModal}
            className={cn("overflow-x-hidden")}
            onClose={onCloseModal}
            closeOnClickOutside={false}
        >
            <Modal.Content width={489} >
                <Modal.Header>
                    <Modal.Title>Autorizantes de la solicitud </Modal.Title>
                    <Modal.Close onClose={() => onCloseModal()} />
                </Modal.Header>
                <PanelAutorizantes autorizantes={autorizantes} />
            </Modal.Content>
        </Modal.Container>
    )
}
